/* ============================================================================
   Phase 7: Q&A lazy-reveal + complementary ±30% price filter
   ============================================================================ */
(function () {
  'use strict';

  // ── 1. Lazy-reveal: IntersectionObserver for [data-lazy-reveal] elements ──
  // 100px pre-load offset so content is visible before the user reaches it.
  if (typeof IntersectionObserver !== 'undefined') {
    var lazyRevealObs = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            entries[i].target.setAttribute('data-visible', '');
            lazyRevealObs.unobserve(entries[i].target);
          }
        }
      },
      { rootMargin: '100px 0px' }
    );

    function observeLazyReveal() {
      var els = document.querySelectorAll('[data-lazy-reveal]');
      for (var i = 0; i < els.length; i++) {
        lazyRevealObs.observe(els[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeLazyReveal);
    } else {
      observeLazyReveal();
    }
  } else {
    // Fallback: make all lazy-reveal elements visible immediately
    var style = document.createElement('style');
    style.textContent = '.fk-lazy-reveal { opacity: 1 !important; }';
    document.head.appendChild(style);
  }

  // ── 2. Complementary products ±30% price filter ───────────────────────────
  // After product-recommendations loads its content, hide cards outside range.
  function filterComplementary(container) {
    var currentPrice = parseInt(container.getAttribute('data-current-price') || '0', 10);
    if (!currentPrice) return;

    var min = Math.round(currentPrice * 0.7);
    var max = Math.round(currentPrice * 1.3);

    var items = container.querySelectorAll('li[data-price]');
    for (var i = 0; i < items.length; i++) {
      var price = parseInt(items[i].getAttribute('data-price') || '0', 10);
      if (price > 0 && (price < min || price > max)) {
        items[i].hidden = true;
        items[i].setAttribute('aria-hidden', 'true');
      }
    }
  }

  function initComplementaryFilter() {
    var containers = document.querySelectorAll('product-recommendations[data-current-price]');
    if (!containers || !containers.length) return;

    for (var i = 0; i < containers.length; i++) {
      (function (container) {
        // MutationObserver: fire when children are added (after AJAX render)
        var obs = new MutationObserver(function (mutations) {
          for (var m = 0; m < mutations.length; m++) {
            if (mutations[m].addedNodes.length > 0) {
              filterComplementary(container);
              obs.disconnect();
              break;
            }
          }
        });
        obs.observe(container, { childList: true, subtree: true });
        // Also run immediately in case already rendered (e.g. page cache)
        filterComplementary(container);
      })(containers[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initComplementaryFilter);
  } else {
    initComplementaryFilter();
  }
}());
